<template>
  <div class="mic_container">
      <div>
        <iframe
            :src="quizPage"
            style="position:fixed; top:0; left:0; bottom:0; right:0; width:100%; height:100%; border:none; margin: 75px 0px; padding:0; overflow:hidden;"
            frameborder="0" >
           </iframe>
      </div>
    <!-- <div v-html="quizPage"></div> -->
  </div>
</template>

<script>
export default {
  data () {
    return {
      quizPage: '',
      id: ''
    }
  },
  beforeMount () {
    this.id = this.$route.params.id
    this.quizPage = `${process.env.ROOT_API}/crawler/api/v1/quiz/${this.id}`
  }
}
</script>

<style scoped="true">
.container {
  max-width: 100vh !important;
}
</style>



// WEBPACK FOOTER //
// src/quiz/QuizPage.vue